import { StyleSheet } from 'react-native';

import { primitive, spacing } from 'styles/constants';

export const styles = StyleSheet.create({
  separator: { flex: 1 },
  row: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  horizontalContainer: {
    display: 'flex',
    flexDirection: 'row',
    flex: 1,
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginLeft: spacing.$6,
    gap: spacing.$4,
  },
  option: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    alignItems: 'center',
    padding: spacing.$3,
    borderBottomColor: primitive.$blackOpacity10,
    paddingHorizontal: spacing.$2,
  },
});
